import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { Moment } from 'moment-timezone';
import React from 'react';
import { WaitlistPickerField } from './WaitlistPickerField';

interface WaitlistDateFieldProps {
    label: string;
    value: Moment | null;
    minDate: Moment;
    shouldDisableDate?: (date: Moment) => boolean;
    onChange: (date: Moment) => void;
}

export const WaitlistDateField: React.FC<WaitlistDateFieldProps> = ({
    label,
    value,
    minDate,
    shouldDisableDate,
    onChange
}) => {
    const [isOpen, setIsOpen] = React.useState(false);

    return (
        <LocalizationProvider
            dateAdapter={AdapterMoment}
            dateFormats={{ monthAndYear: 'MMM YYYY' }}
        >
            <DesktopDatePicker<Moment, Moment>
                open={isOpen}
                value={value}
                minDate={minDate}
                shouldDisableDate={shouldDisableDate}
                PopperProps={{ placement: 'bottom-start' }}
                onOpen={() => setIsOpen(true)}
                onClose={() => setIsOpen(false)}
                onChange={date => {
                    if (date?.isValid()) {
                        onChange(date);
                    }
                }}
                renderInput={({ inputRef }) => (
                    // The picker anchors its popper to the element holding `inputRef`.
                    <WaitlistPickerField
                        ref={inputRef as React.Ref<HTMLButtonElement>}
                        label={label}
                        open={isOpen}
                        value={value?.format('ddd, D MMM YYYY')}
                        placeholder="Select date"
                        onClick={() => setIsOpen(true)}
                    />
                )}
            />
        </LocalizationProvider>
    );
};
